import React, { useState } from "react";
import { QuotationFormHeader, QuotationFormProps } from "./QuotationForm";
import { Step, StepLabel, Stepper } from "@mui/material";
import { Button } from "../../../../../../stories/Button/Button";
import { LabelProps } from "../../../../../../utils/types";
import { Label } from "../../../../../../stories/Label/Label";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import Input from "../../../../../../stories/Input/Input";
import FileAttach from "../../../../../../images/BrowseFiles.svg";
import Upload from "../../../../../../images/Upload.svg";
import { useNavigate } from "react-router-dom";
import { PageFor } from "../../../../../../utils/Enum.types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useFormJson from "../../../../../../json/useFormJson";

interface Props extends QuotationFormProps {
  pageType: PageFor;
}

const SupplierTerms = ({ step, pageType }: Props) => {
  const navigate = useNavigate();
  const {Quotation}=useFormJson();
  const { uuid } = useUrlParams();
  const stepsHeader = QuotationFormHeader();
  const [file, setFile] = useState<File | null>(null);
  const [browse, setBrowse] = useState(false);
  const handleImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      let image_as_files = e.target.files[0];
      setFile(image_as_files);
    }
  };
  return (
    <>
      <div className="supplier-terms">
        <div className="supplier-terms__block">
          {pageType === PageFor.GENERAL && (
            <>
              <div className="supplier-terms__block--header">
                <b>Fill Quotation Form</b>
              </div>
              <div className="supplier-terms__block--stepper">
                <Stepper alternativeLabel activeStep={step - 1}>
                  {stepsHeader.map((step, index) => {
                    return (
                      <Step key={index}>
                        <StepLabel>{step}</StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </div>
            </>
          )}

          {/* use below div for form */}
          <div className="supplier-terms__block--form">
            <div className="supplier-terms__block--form--flex row g-0">
              <div className="col supplier-terms__block--form--left">
                {Quotation.FillItem.SupplierTerms.GeneralTerms.map(
                  (field: LabelProps, key: React.Key) => {
                    return (
                      <div className="label-grid">
                        <Label>{field.labelName}</Label>
                        <TextArea rows={2} disabled />
                      </div>
                    );
                  }
                )}
              </div>
              <div className="col supplier-terms__block--form--right">
                {Quotation.FillItem.SupplierTerms.Terms.map(
                  (field: LabelProps, key: React.Key) => {
                    if (field.dataType === "textarea") {
                      return (
                        <div className="label-grid">
                          <Label>{field.labelName}</Label>
                          <TextArea
                            rows={2}
                            disabled={pageType === PageFor.MODAL}
                          />
                        </div>
                      );
                    } else
                      return (
                        <div className="label-grid">
                          <Label>{field.labelName}</Label>
                          <Input
                            type={field.dataType}
                            disabled={pageType === PageFor.MODAL}
                          />
                        </div>
                      );
                  }
                )}
                <div className="label-grid">
                  <Label>Upload Product details(if any)</Label>
                  {pageType === PageFor.GENERAL ? (
                    <div className="items__add--form--flex">
                      <Input value={file?.name} disabled />
                      {!browse ? (
                        <>
                          <label className="items__add--form--details--browse">
                            <img
                              src={FileAttach}
                              alt="/"
                              className="browse-icon"
                            />
                            Browse
                            <input
                              id="student-documents__browse--inputTag"
                              type="file"
                              className="assignment-creation__fileattach--input"
                              onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                              ) => {
                                handleImagePreview(e);
                                setBrowse(!browse);
                              }}
                              accept="jpg, .png, .jpeg"
                            />
                          </label>{" "}
                        </>
                      ) : (
                        <>
                          <button className="items__add--form--details--upload">
                            <img src={Upload} alt="" />
                            Upload
                          </button>
                        </>
                      )}
                    </div>
                  ) : (
                    <Input disabled />
                  )}
                </div>
              </div>
            </div>

            {pageType === PageFor.GENERAL && (
              <>
                <Button
                  mode="save"
                  onClick={() =>
                    navigate(`/${uuid}/quotationform/reviewandsubmit`)
                  }
                />
                <Button mode="back" onClick={() => navigate(-1)} />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SupplierTerms;
